<template lang="html">
  <section class="app-read-project-type" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(projects_type, idx) in project_types">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{projects_type.type}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>project_type_id : </strong>{{projects_type.project_type_id}}</div>
              <div><strong>type : </strong>{{projects_type.type}}</div>
              <div><strong>date_created : </strong>{{projects_type.date_created}}</div>
              <div><strong>date_updated : </strong>{{projects_type.date_updated}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-primary"
                    @click="navigateAway({id: projects_type.project_type_id, title: projects_type.type}, 'update')">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: projects_type.project_type_id, title: projects_type.type}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default  {
  name: 'ReadProjectsType',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.project_types = data)
      .catch()
  },
  data () {
    return {
      project_types: null,
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-project-type {}
</style>



// WEBPACK FOOTER //
// src/components/projects_types/ReadProjectsType.vue